import { log, supabase } from ".";

// Normaliza string vacío a null para columnas numéricas/date (PostgREST rechaza "");
// preserva 0 y valores válidos. No se aplica a texto (las columnas text aceptan "").
const vacioANull = (v) => (v === "" ? null : v);

// PATCH no-destructivo sobre `edificios` (regla 10.54). Cada campo entra al PATCH
// SOLO si `!== undefined`: pasar el objeto entero o un parcial NUNCA nulifica un
// campo que no se referenció. Seguro por construcción.
export const updateEdificio = async (campos) => {
  const {
    id,
    // ── Legacy (antes incondicionales; ahora condicionales) ──
    personas,
    estacionamientos,
    empresaslistado,
    empresasdestacadas,
    contrato_fechainicio,
    contrato_fechafin,
    contratos,
    inicio_servicio,
    lat,
    lng,
    // ── Identidad / ubicación ──
    edificio,
    estado,
    ubicacion,
    direccion,
    alianza,
    circuitos,
    programatica,
    is_programmatic,
    proveedor_id,
    // ── Pantallas / estacionamiento ──
    pantallas,
    totems,
    espera,
    cowork,
    estacionamientos_ocupacion,
    // ── Comisión variable (1/2/3) ──
    comision_1_porcentaje,
    comision_1_fechainicio,
    comision_1_fechafin,
    comision_2_porcentaje,
    comision_2_fechainicio,
    comision_2_fechafin,
    comision_3_porcentaje,
    comision_3_fechainicio,
    comision_3_fechafin,
    // ── Comisión fija (incluye comision_fija_fin, no manejado hasta ahora) ──
    comision_fija_monto,
    comision_fija_moneda,
    comision_fija_inicio,
    comision_fija_fin,
  } = campos;

  try {
    const updatedData = {};

    // ── Legacy: ahora condicionales para no nulificar lo no-referenciado.
    //    Se mantiene la normalización (parseInt / join / `|| null`) solo si el campo viene. ──
    if (personas !== undefined) {
      updatedData.personas = typeof personas === "string" ? parseInt(personas.replace(/,/g, ""), 10) : personas;
    }
    if (estacionamientos !== undefined) {
      updatedData.estacionamientos =
        typeof estacionamientos === "string" ? parseInt(estacionamientos.replace(/,/g, ""), 10) : estacionamientos;
    }
    if (empresaslistado !== undefined) updatedData.empresaslistado = empresaslistado || null;
    if (empresasdestacadas !== undefined) updatedData.empresasdestacadas = empresasdestacadas || null;

    // ── Contrato / servicio / coords (ya eran condicionales) ──
    if (contrato_fechainicio !== undefined) updatedData.contrato_fechainicio = contrato_fechainicio || null;
    if (contrato_fechafin !== undefined) updatedData.contrato_fechafin = contrato_fechafin || null;
    if (contratos !== undefined) updatedData.contratos = contratos;
    if (inicio_servicio !== undefined) updatedData.inicio_servicio = inicio_servicio || null;
    if (lat !== undefined) updatedData.lat = lat;
    if (lng !== undefined) updatedData.lng = lng;

    // ── Identidad / ubicación (texto: passthrough) ──
    if (edificio !== undefined) updatedData.edificio = edificio;
    if (estado !== undefined) updatedData.estado = estado;
    if (ubicacion !== undefined) updatedData.ubicacion = ubicacion;
    if (direccion !== undefined) updatedData.direccion = direccion;
    if (alianza !== undefined) updatedData.alianza = alianza;
    if (circuitos !== undefined) updatedData.circuitos = circuitos;
    if (programatica !== undefined) updatedData.programatica = programatica;
    if (is_programmatic !== undefined) updatedData.is_programmatic = is_programmatic;
    if (proveedor_id !== undefined) updatedData.proveedor_id = vacioANull(proveedor_id);

    // ── Pantallas / estacionamiento (numérico: "" → null) ──
    if (pantallas !== undefined) updatedData.pantallas = vacioANull(pantallas);
    if (totems !== undefined) updatedData.totems = vacioANull(totems);
    if (espera !== undefined) updatedData.espera = vacioANull(espera);
    if (cowork !== undefined) updatedData.cowork = vacioANull(cowork);
    if (estacionamientos_ocupacion !== undefined)
      updatedData.estacionamientos_ocupacion = vacioANull(estacionamientos_ocupacion);

    // ── Comisión variable (% numérico → "" a null; fechas date → "" a null) ──
    if (comision_1_porcentaje !== undefined) updatedData.comision_1_porcentaje = vacioANull(comision_1_porcentaje);
    if (comision_1_fechainicio !== undefined) updatedData.comision_1_fechainicio = comision_1_fechainicio || null;
    if (comision_1_fechafin !== undefined) updatedData.comision_1_fechafin = comision_1_fechafin || null;
    if (comision_2_porcentaje !== undefined) updatedData.comision_2_porcentaje = vacioANull(comision_2_porcentaje);
    if (comision_2_fechainicio !== undefined) updatedData.comision_2_fechainicio = comision_2_fechainicio || null;
    if (comision_2_fechafin !== undefined) updatedData.comision_2_fechafin = comision_2_fechafin || null;
    if (comision_3_porcentaje !== undefined) updatedData.comision_3_porcentaje = vacioANull(comision_3_porcentaje);
    if (comision_3_fechainicio !== undefined) updatedData.comision_3_fechainicio = comision_3_fechainicio || null;
    if (comision_3_fechafin !== undefined) updatedData.comision_3_fechafin = comision_3_fechafin || null;

    // ── Comisión fija (período cerrable: inicio + fin) ──
    if (comision_fija_monto !== undefined) updatedData.comision_fija_monto = vacioANull(comision_fija_monto);
    if (comision_fija_moneda !== undefined) updatedData.comision_fija_moneda = comision_fija_moneda;
    if (comision_fija_inicio !== undefined) updatedData.comision_fija_inicio = comision_fija_inicio || null;
    if (comision_fija_fin !== undefined) updatedData.comision_fija_fin = comision_fija_fin || null;

    // Llama a la función personalizada 'update'
    const data = await supabase.update("edificios", updatedData, id);

    // Log de depuración
    log.debug("updateEdificio", data);
    return data;
  } catch (error) {
    log.error("updateEdificio", error);
    throw error;
  }
};
